/* Imports */
import AuthService from "@/services/auth.service";
/* /Imports/ */

/* 
  Retrieve user from the local storage.
*/
const user = JSON.parse(localStorage.getItem("user"));

/* 
  Change the status of the user.
*/
const initialState = user
  ? { status: { loggedIn: true }, user }
  : { status: { loggedIn: false }, user: null };

/* 
  Module: AuthModule
  Description: This module representing different actions with authentication.
*/
export const auth = {
  /*
    Self-contained/reusable module.
  */
  namespaced: true,

  /*
    Initial state in this module.
  */
  state: initialState,

  /*
    Define actions for separate different logic. 
  */
  actions: {
    /* 
      Call AuthService class then dispatch login action.
    */
    login({ commit }, user) {
      return AuthService.login(user).then(
        (user) => {
          commit("loginSuccess", user);
          return Promise.resolve(user);
        },
        (error) => {
          commit("loginFailure");
          return Promise.reject(error);
        }
      );
    },

    /* 
      Call AuthService class then dispatch register action.
    */
    register({ commit }, user) {
      return AuthService.register(user).then(
        (response) => {
          commit("registerSuccess");
          return Promise.resolve(response.data);
        },
        (error) => {
          commit("registerFailure");
          return Promise.reject(error);
        }
      );
    },

    /* 
      Call AuthService class then dispatch logout action.
    */
    logout({ commit }) {
      AuthService.logout();
      commit("logout");
    }
  },

  /*
    Define mutations for separate different states. 
  */
  mutations: {
    /* 
      If user successfully login into account.
    */
    loginSuccess(state, user) {
      state.status.loggedIn = true;
      state.user = user;
    },

    /* 
      If user unsuccessfully login into account.
    */
    loginFailure(state) {
      state.status.loggedIn = false;
      state.user = null;
    },

    /* 
      If user successfully create account.
    */
    registerSuccess(state) {
      state.status.loggedIn = false;
    },

    /* 
      If user unsuccessfully create account.
    */
    registerFailure(state) {
      state.status.loggedIn = false;
    },

    /* 
      If user logout.
    */
    logout(state) {
      state.status.loggedIn = false;
      state.user = null;
    }
  }
};
